import { apiClient } from './api/apiClient';
import type { User } from '../types/user';
import type { Farm } from '../types/farm';
import type { FarmApiDTO } from '../types/api';
import { mapFarmDtoToFarm } from '../types/api';

/**
 * /me API レスポンス型
 */
interface MeResponse {
  uid: string;
  email: string;
  role: string;
  userId: number;
  name: string;
  permission: Record<string, unknown>;
}

/**
 * ユーザーサービス
 * /me API を通じてログインユーザーの情報と権限データを取得する
 */
class UserService {
  /**
   * ログインユーザー情報を取得する
   * @returns ユーザー情報
   */
  async getMe(): Promise<User> {
    const response = await apiClient.get<MeResponse>('/me');
    return {
      uid: response.uid,
      email: response.email,
      role: response.role as User['role'],
      userId: response.userId,
      name: response.name,
      permission: response.permission as User['permission'],
    };
  }

  /**
   * ログインユーザーがアクセス可能な農場一覧を取得する
   * @returns 農場一覧
   */
  async getMyFarms(): Promise<Farm[]> {
    const response = await apiClient.get<FarmApiDTO[]>('/me/farms');
    return response.map(mapFarmDtoToFarm);
  }
}

/** ユーザーサービスのシングルトンインスタンス */
export const userService = new UserService();
